import BaseTokenProvider from './BaseTokenProvider'

var ObjectTokenProvider = function() {
    BaseTokenProvider.call(this);
};
ObjectTokenProvider.prototype = new BaseTokenProvider();

/**
 * @inheritDoc
 */
ObjectTokenProvider.prototype.getSupportedTokens = function () {
    return ["object", "description", "summary", "label", "id", "name"];
};

ObjectTokenProvider.prototype.resolveTextToken = function(mapObject, token, field, defaultValue) {
    if (mapObject != null) {
        if (field == "name" || token == "name") {
            if (typeof mapObject.name !== 'undefined' && mapObject.name != null) {
                return mapObject.name;
            }
        } else if (field == "id" || token == "id") {
            return mapObject.getUIID().toString(36);
        } else if (field == "description" || token == "description") {
            return mapObject.description;
        } else if (field == "summary" || token == "summary") {
            return mapObject.summary;
        } else if ((field == "label" || token == "label") && mapObject.getClassName() === "PointInterest") {
            return mapObject.label;
        }
    }
    return defaultValue;
}

export default ObjectTokenProvider;